// REACT
import React from 'react'

// PAGINAS
import Home from 'Pages/Home/Home'
import Hotel from 'Pages/Hotel/Hotel'
import ServicesIntro from 'Pages/Services/ServicesIntro'

const Index: React.FC = () => {
	return (
		<>
			<Home />
			<Hotel />
			<ServicesIntro/>
		</>
	)
}

export default Index
